import request from '@/utils/request2';
export function claimsList(data) {
  return request.post('admin/audit/ayw-claims-list', data);
}
export function claimsCustomer(data) {
  return request.post('admin/claims-management/customer', data);
}
export function policyDetail(data) {
  return request.post('admin/policy/resource', data);
}

// 审核进度
export function auditSchedule(data) {
  return request.post('admin/audit/schedule', data);
}

// 审核详情
export function auditDetail(data) {
  return request.post('admin/audit/detail', data);
}

// 审核操作
export function auditOperate(data) {
  return request.post('admin/v2/group-insurance/special-operate', data);
}

//获取审核概要信息
export function groupInsuranceDetail(data) {
  return request.post('admin/v2/group-insurance/group-insurance-detail', data);
}
export function groupInsurancePack(data) {
  return request.post('admin/v2/group-insurance/pack', data);
}